import { render, staticRenderFns } from "./redEnvelope.vue?vue&type=template&id=c09796d0&scoped=true"
import script from "./redEnvelope.vue?vue&type=script&lang=js"
export * from "./redEnvelope.vue?vue&type=script&lang=js"
import style0 from "./redEnvelope.vue?vue&type=style&index=0&id=c09796d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09796d0",
  null
  
)

export default component.exports